// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled-chips-field{padding:5px;text-align:left;min-height:34px;line-height:34px;border-bottom:1px solid #d8d8d8}\n", ""]);
// Exports
module.exports = exports;
